<template>
  <v-dialog v-model="show" persistent max-width="650px">
    <v-card  min-height="80vh">
      <v-toolbar  color="green lighten-3" dark>
        <v-toolbar-title class="headline"
          >Kränkningsanmälan</v-toolbar-title
        >
      </v-toolbar>
      <!-- <v-card-text> -->


 <v-window v-model="step" min-height='60vh' >
     <v-window-item :value="1">
              <div class="pa-3 text-xs-center big" >
       <h3 class="title font-weight-light mb-2">Vad är en kränkningsanmälan?</h3>
          <span class="caption grey--text">En kränkningsanmälan ska skapas om du som skolpersonal, vårdnadshavare eller elev ser eller upplever att någon kränks, mobbas, diskrimineras eller trakaseras.</span>
          <!-- <span class="caption grey--text">Du ska svara på frågorna i lugn och ro och får gärna gå tillbaka och ändra svaren i efterhand om din uppfattning har ändrats. Det är helt okej att inte svara på frågor om man inte har någon uppfattning..</span>
          <span class="caption red--text">Hinner du bara fylla i några frågor? Det gör inget, tryck på skicka in så kan du fortsätta nästa gång du får tid.</span> -->
          

          

    <v-divider id="space"></v-divider>

              <div v-if="id==''">
                    <v-text-field
            label="Ditt namn"
            placeholder="Ann Anka"
            v-model="MoreInfo.Name"
          ></v-text-field>
              <v-text-field
            label="Din mail"
            placeholder="ann@anka.se"
            v-model="MoreInfo.Mail"
          ></v-text-field>
              <v-text-field
            label="Ditt nummer"
            placeholder="07012345"
            v-model="MoreInfo.Number"
          ></v-text-field>
               <h4 id="" class="">Jag vill att någon från skolan återkopplar till mig. </h4>
  <v-radio-group v-model="MoreInfo.Feedback" row>
              <v-radio label="Ja" value="1"></v-radio>
              <v-radio label="Nej" value="0"></v-radio>
            </v-radio-group>
              </div>
              </div>
      </v-window-item>
      <v-window-item :value="2">
        <v-card-text>
           <span class="headline" id="head">Karaktär: </span>
          <div v-for="(item, index) in Questions.slice(0, 4)" :key="index">
            <span id="bellow" class="title font-weight-regular justify-space-between">  {{ item.Q }} </span>
              <div v-if="item.T == 'T'" >
                    <v-textarea
          solo
          v-model="Answers[index]"
          name="input-7-4"
          label="Efter bästa förmåga"
        ></v-textarea>
            </div>
               <div  v-else-if="item.T == 'YN'"  >
             <v-radio-group v-model="Answers[index]" row>
              <v-radio label="Ja" value="1"></v-radio>
              <v-radio label="Nej" value="0"></v-radio>
              <v-radio label="Vet inte" value="2"></v-radio>
            </v-radio-group>
               </div>
          </div>
        </v-card-text>
      </v-window-item>

      <v-window-item :value="3">
                   <v-card-text>
           <span class="headline" id="head">När &  var </span>
          <div v-for="(item, index) in Questions.slice(4, 6)" :key="index">
            <span id="bellow" class="title font-weight-regular justify-space-between">  {{ item.Q }} </span>
              <div v-if="item.T == 'T'" >
                    <v-textarea
          solo
          v-model="Answers[index+4]"
          name="input-7-4"
          label="Efter bästa förmåga"
        ></v-textarea>
            </div>
               <div  v-else-if="item.T == 'YN'"  >
             <v-radio-group v-model="Answers[index+4]" row>
              <v-radio label="Ja" value="1"></v-radio>
              <v-radio label="Nej" value="0"></v-radio>
              <v-radio label="Vet inte" value="2"></v-radio>
            </v-radio-group>
               </div>
                <div  v-else-if="item.T == 'Date'"  >
                     <v-date-picker
                        v-model="DT.Date"
                     :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
        min="2020-01-01"
                     ></v-date-picker>
                     <v-time-picker
                        v-model="DT.Time"
  format="24hr"
></v-time-picker>
               </div>
          </div>
        </v-card-text>
      </v-window-item>
      <v-window-item :value="4">
                   <v-card-text>
           <span class="headline" id="head">Händelseförlopp </span>
          <div v-for="(item, index) in Questions.slice(6,9)" :key="index">
            <span id="bellow" class="title font-weight-regular justify-space-between">  {{ item.Q }} </span>
              <div v-if="item.T == 'T'" >
                    <v-textarea
          solo
          v-model="Answers[index+6]"
          name="input-7-4"
          label="Efter bästa förmåga"
        ></v-textarea>
            </div>
               <div  v-else-if="item.T == 'YN'"  >
             <v-radio-group v-model="Answers[index+6]" row>
              <v-radio label="Ja" value="1"></v-radio>
              <v-radio label="Nej" value="0"></v-radio>
              <v-radio label="Vet inte" value="2"></v-radio>
            </v-radio-group>
               </div>
          </div>
        </v-card-text>
      </v-window-item>
            <v-window-item :value="5">
                   <v-card-text>
           <span class="headline" id="head">Uppföljning </span>
          <div v-for="(item, index) in Questions.slice(9,12)" :key="index">
            <span id="bellow" class="title font-weight-regular justify-space-between">  {{ item.Q }} </span>
              <div v-if="item.T == 'T'" >
                    <v-textarea
          solo
          v-model="Answers[index+9]"
          name="input-7-4"
          label="Efter bästa förmåga"
        ></v-textarea>
            </div>
               <div  v-else-if="item.T == 'YN'"  >
             <v-radio-group v-model="Answers[index+9]" row>
              <v-radio label="Ja" value="1"></v-radio>
              <v-radio label="Nej" value="0"></v-radio>
              <v-radio label="Vet inte" value="2"></v-radio>
            </v-radio-group>
               </div>
          </div>
        </v-card-text>
      </v-window-item>
           <v-window-item :value="6">
                <div class="pa-3 text-xs-center big">
          <v-img id="spaceUp"
            class="mb-3"
            contain
            height="128"
            src="https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/120/samsung/320/thumbs-up_1f44d.png"
          ></v-img>
          <h3 class="title font-weight-light mb-2">Du är nu klar!</h3>
          <span class="caption grey--text">Bra jobbat!</span>
          <br>
            <v-btn color="green lighten-1" text dark @click="change()">
          Skicka in!
        </v-btn>   
        </div>



                  
      </v-window-item>
    </v-window>

    <v-divider></v-divider>

    <v-card-actions>   

      <v-btn
        :disabled="step === 1"
        flat
        @click="step--"
      >
        Tillbaka
      </v-btn>
      <v-spacer></v-spacer>

   <v-item-group
        class="text-xs-center"
        mandatory
      >
        <v-item
          v-for="n in 6"
          :key="`btn-${n}`"
        >
          <v-btn           
                      icon   
                      :color="step==n?'green lighten-1':step>n?'green lighten-3':'yellow lighten-3'"     
        @click="step= n"
          >
            <v-icon>{{n==6?'star':n==1?'info':'rule'}}</v-icon>
          </v-btn>
        </v-item>
      </v-item-group>
      <v-spacer></v-spacer>

      <v-btn
        :disabled="step === 6"
        color="primary"
        depressed
        @click="step++"
      >
        Nästa
      </v-btn>
    </v-card-actions>
               <v-btn color="red lighten-1" text dark @click="show=false">
          Avbryt
        </v-btn>
        
   <!-- {{Answers}}   {{MoreInfo}} -->
  </v-card>

  </v-dialog>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "Violations",

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  created() {},
  props: {
    // student: Object,
    value: Boolean,
    id: String,
    schoolId: String,
    typ: String,
    // Answers: Array
  },
  data() {
    return {
      step:1,
Questions: [
        { Q: "Mobbning:", T: "YN" },//5 Kunskapsinhämtning 
        { Q: "Kränkande behandling :", T: "YN" },//5 Kunskapsinhämtning 
        { Q: "Diskriminering	:", T: "YN" },//5 Kunskapsinhämtning 
        { Q: "Trakasserier	:", T: "YN" },//5 Kunskapsinhämtning 
        //4

         { Q: "Plats där kränkningen ägde rum:", T: "T" }, //2 MÅL kunskapsinhämtning
        { Q: "Tidpunkt när kränkningen ägde rum:", T: "Date" }, //5!
//6
        { Q: "Person eller personer som utfört den kränkande behandlingen:", T: "T" },   //1     hälsa kunskapsinhämtning
        { Q: "Personer som såg vad som hände, utöver den utsatta personen:", T: "T" }, //3 Kunskapsinhämtning 
        { Q: "Beskrivning av händelse eller händelser:", T: "T" },//4 Kunskapsinhämtning
//9
        { Q: "Pågår den kränkande behandlingen fortfarande?", T: "YN" },//5 Kunskapsinhämtning 
        { Q: "Har du varit i direktkontakt med skolan/verksamheten?", T: "YN" },//5 Kunskapsinhämtning 
        { Q: "Vem har du i så fall kontaktat?", T: "T" },//11

      ],
      Answers: [],
      OldAnswers: [],
      DT: {"Date":null,"Time":null},
      MoreInfo:{}
    };
  },

  methods: {



    ...mapActions("violations", ["createViolation"]),
    ...mapActions(["showSuccessSnackbar"]),
    change() {

let datetime= new Date(this.DT.Date+"T"+this.DT.Time);
let output={}
this.Answers[5]=datetime.getTime();
output.Answers =this.Answers;
if(Object.keys(this.MoreInfo).length === 0 && this.MoreInfo.constructor === Object)
 { output.Contact=this.id
  output.Typ=this.typ
 }
 else{
  output.Contact=this.MoreInfo
  output.Typ="extern"
 } 

  output.schoolId=this.schoolId

this.MoreInfo={}
this.Answers=[]
this.DT = {"Date":null,"Time":null}
//console.log(output)
       this.createViolation(output);
        this.showSuccessSnackbar("Kartläggningen är uppdaterad. Bra jobbat!");
      // }
           this.show = false;
    },
  },
};
</script>
<style >
#head{
  background-color: #F06292;
  color:white;
  padding: 5px;
  border-radius: 10px;
  margin-bottom: 40px !important;
}
#side{ width: 350px;}

#bellow{ margin-left: 5px;}

.big{
  min-height: 55.5vh;
}
.v-picker--date {
    height: 400px;
}
.v-picker--time {
  /* margin-left:20px; */
    height: 400px;
}
/* .v-picker__title
{
  height:56px;
} */
.v-picker__title primary
{
  height:56px;
}
.v-window-item{
  min-height: 455px;
}
#space{
  margin-bottom: 20%;
}
#spaceUp{
  margin-top: 35%;
}
</style>